import { render, staticRenderFns } from "./KioskDonutIndicator.vue?vue&type=template&id=24111dfa&lang=pug"
import script from "./KioskDonutIndicator.vue?vue&type=script&lang=js"
export * from "./KioskDonutIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports